export function getFrequencyLabel(frequency) {
    if (!frequency || typeof frequency !== "object") return String(frequency ?? "")
    const { period } = frequency
    return `${frequency.interval ?? ""}${period?.[0] ?? ""}`
}
